import { useStore } from "../context/StoreContext";

export const Marquee = () => {
  const { t } = useStore();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="relative overflow-hidden border-y border-stone-200/80 bg-[#1C1917] py-4 select-none" data-testid="editorial-marquee">
      <div className="marquee-track flex whitespace-nowrap">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center">
            {items.map((phrase, i) => (
              <span key={`${dup}-${i}`} className="flex items-center gap-8 px-8 text-[12px] font-mono uppercase tracking-[0.3em] text-[#EFEAE1]/80">
                {phrase}
                <span className="text-[#C85A32]">✳</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
